import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import Breadcrumb from "../../../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import { formatUnitsForReport } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";

const BranchItemTransferReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const { SearchBar } = Search;
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [allBranches, setAllBranches] = useState([]);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
    loadAllBranches();
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
      setAllOrders([]);
    }
  }, [dateFrom, dateTo]);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setFilteredOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      const url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_transfer_items";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch,
        date_from: dateFrom,
        date_to: dateTo,
      });
      if (requestId !== ordersRequestId.current) return false;
      if (response && response.status === 1) {
        const allData = (response.data || []).map((row, index) => {
          const item_details = row.item_details || [];
          const total_cost = item_details.reduce(
            (acc, item) => Number(acc) + Number(item.total_cost || 0),
            0,
          );
          return {
            ...row,
            row_key: row.id || `${row._id}_${index}`,
            branch_from_name:
              row.branch_from && row.branch_from.name
                ? row.branch_from.name
                : "",
            branch_to_name:
              row.branch_to && row.branch_to.name ? row.branch_to.name : "",
            total_cost: Number(total_cost.toFixed(2)),
            item_details,
          };
        });
        if (allData.length <= 0) {
          showNotification("No Orders data found", "error");
        }
        setAllOrders(allData);
        setFilteredOrders(allData);
      } else {
        showNotification((response && response.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      console.log(error);
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      let res = response.data.filter((obj) => obj.type === "Branch");
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [itemModal, setItemModal] = useState(false);
  function detailsFormatter(cell, row) {
    return (
      <>
        <span className="text-info" style={{ marginLeft: "5px" }}>
          <i
            className="bx bx-news font-size-15"
            title="View"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRow(row);
              setItemModal(!itemModal);
            }}
          ></i>
        </span>
      </>
    );
  }

  function afterFilter(newResult) {
    setFilteredOrders((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Order Id"),
      dataField: "order_id",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Branch from"),
      dataField: "branch_from_name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.branch_from_name)
                .map((row) => [
                  row.branch_from_name,
                  { value: row.branch_from_name, label: row.branch_from_name },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Branch to"),
      dataField: "branch_to_name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.branch_to_name)
                .map((row) => [
                  row.branch_to_name,
                  { value: row.branch_to_name, label: row.branch_to_name },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Status"),
      dataField: "status",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.status)
                .map((row) => [
                  row.status,
                  { value: row.status, label: row.status },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Remarks"),
      dataField: "remarks",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Date"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      sort: true,
      dataField: "createdAt",
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Total Cost"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      sort: true,
      dataField: "total_cost",
      formatter: (cell, row) => {
        return Number(row.total_cost || 0).toFixed(2);
      },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Action"),
      dataField: "action_col",
      isDummyField: true,
      formatter: detailsFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];

  const handleDownload = async () => {
    const fileName = "branch_item_transfer_report";
    const exportType = "xls";

    let data_to_export =
      filteredOrders && filteredOrders.length ? filteredOrders : allOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          OrderId: v.order_id,
          BranchFrom: v.branch_from_name,
          BranchTo: v.branch_to_name,
          Status: v.status,
          Remarks: v.remarks,
          Date: moment(v.updatedAt || v.createdAt).format("DD/MM/YYYY"),
          TotalCost: Number(v.total_cost || 0).toFixed(2),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const columns_item = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Cost"),
      dataField: "total_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branch Item Transfer Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branch Item Transfer Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="branch"
                          label={props.t("Branch")}
                          type="select"
                          value={selectedBranch}
                          onChange={(e) => {
                            setSelectedBranch(e.target.value);
                          }}
                        >
                          <option value="All">{props.t("Select")}</option>
                          {allBranches &&
                            allBranches.map((branch) => {
                              return (
                                <option key={branch._id} value={branch._id}>
                                  {branch.name}
                                </option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          {isLoadingOrders ? (
                            <Spinner size="sm" className="mr-1" />
                          ) : (
                            <i className="mdi mdi-checkbox-marked-circle"></i>
                          )}{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>

                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Branch Item Transfer Report")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="row_key"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          {isLoadingOrders ? (
                            <div className="text-center py-5">
                              <Spinner color="primary" />
                            </div>
                          ) : (
                            <BootstrapTable
                              striped
                              hover
                              condensed
                              filter={filterFactory({ afterFilter })}
                              pagination={paginationFactory(pagination_options)}
                              {...toolkitProps.baseProps}
                            />
                          )}
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    isOpen={itemModal}
                    toggle={() => setItemModal(!itemModal)}
                  >
                    <ModalHeader toggle={() => setItemModal(!itemModal)}>
                      {"    "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv1");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                    </ModalHeader>
                    <ModalBody>
                      <Row id="printDiv1">
                        <Col lg={12}>
                          <CardTitle className="text-center">
                            {props.t("Item transfer order details")}
                          </CardTitle>
                          <Card>
                            <CardBody>
                              <Row>
                                <Col lg={12}>
                                  <BootstrapTable
                                    keyField="_id"
                                    data={
                                      selectedRow.item_details &&
                                      selectedRow.item_details
                                    }
                                    columns={columns_item}
                                    striped
                                    hover
                                    condensed
                                    noDataIndication={props.t(
                                      "No data to display.",
                                    )}
                                  />
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(BranchItemTransferReport)),
);
